import { type StoreActionApi } from 'react-sweet-state';

import type { ResearchStepRenderMode } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import type { ChatMessageResearchStore } from './types';
import { updateStep } from './updateStep';

type SetStepTitleArgs = {
	messageId: string;
	stepId: string;
	title: string;
	roundId: number;
	immediate: boolean;
	isSkill?: boolean;
	toolIcon?: string;
	toolName?: string;
	renderMode?: ResearchStepRenderMode;
};

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const setStepTitle: (args: SetStepTitleArgs) => ChatMessageResearchStoreAction =
	({
		messageId,
		stepId,
		title,
		roundId,
		immediate,
		isSkill = false,
		toolIcon,
		toolName,
		renderMode,
	}) =>
	({ dispatch }: StoreActionApi<ChatMessageResearchStore>) => {
		dispatch(
			updateStep({
				messageId,
				stepId,
				updater: (step) => ({
					...step,
					title,
					roundId,
					isSkill,
					immediate,
					completed: false,
					toolIcon,
					toolName,
					renderMode,
				}),
			}),
		);
	};
